import {GeometryConfiguration} from "./geometry-configuration";
import {LayerConfiguration} from "./layer-configuration";
import { JsonObject, JsonProperty } from "typescript-json-serializer";
import {PopupTemplateConfiguration} from "./popup-configuration";
import {SymbolConfiguration} from "./symbol-configuration";

@JsonObject()
export class GraphicConfiguration {
    /**
     * The aggregateGeometries contains spatial aggregation geometries when [statistics](https://developers.arcgis.com/javascript/latest/api-reference/esri-rest-support-StatisticDefinition.html#statisticType) query is executed with `envelope-aggregate`, `centroid-aggregate` and/or `convex-hull-aggregate` statistics type.
     *
     * [Read more...](https://developers.arcgis.com/javascript/latest/api-reference/esri-Graphic.html#aggregateGeometries)
     */
    @JsonProperty()
    declare aggregateGeometries?: any;
    /**
     * Name-value pairs of fields and field values associated with the graphic.
     *
     * [Read more...](https://developers.arcgis.com/javascript/latest/api-reference/esri-Graphic.html#attributes)
     */
    @JsonProperty()
    declare attributes?: any;
    /**
     * The geometry that defines the graphic's location.
     *
     * [Read more...](https://developers.arcgis.com/javascript/latest/api-reference/esri-Graphic.html#geometry)
     */
    @JsonProperty()
    declare geometry?: GeometryConfiguration;
    /**
     * If applicable, references the layer in which the graphic is stored.
     *
     * [Read more...](https://developers.arcgis.com/javascript/latest/api-reference/esri-Graphic.html#layer)
     */
    @JsonProperty()
    declare layer?: LayerConfiguration;
    /**
     * The template for displaying content in a [Popup]
     * (https://developers.arcgis.com/javascript/latest/api-reference/esri-widgets-Popup.html) when the graphic
     * is selected.
     *
     * [Read more...](https://developers.arcgis.com/javascript/latest/api-reference/esri-Graphic.html#popupTemplate)
     */
    @JsonProperty()
    declare popupTemplate?: PopupTemplateConfiguration;
    /**
     * The [Symbol](https://developers.arcgis.com/javascript/latest/api-reference/esri-symbols-Symbol.html) for the
     * graphic.
     *
     * [Read more...](https://developers.arcgis.com/javascript/latest/api-reference/esri-Graphic.html#symbol)
     */
    @JsonProperty()
    declare symbol?: SymbolConfiguration;
    /**
     * Indicates the visibility of the graphic.
     *
     * @default true
     *
     * [Read more...](https://developers.arcgis.com/javascript/latest/api-reference/esri-Graphic.html#visible)
     */
    @JsonProperty()
    declare visible?: boolean;

    constructor() {}
}
